import type { OrderingMenuItem } from '@/domains/pjazza/types/models/OrderingMenu.types.ts'

/** A dish's price as the diner reads it: "€12.50", or "€45.00 / kg" when it is priced per unit (DEC-2026-083). */
export const formatMenuItemPrice = (item: Pick<OrderingMenuItem, 'price' | 'pricingUnitSymbol'>): string =>
  item.pricingUnitSymbol ? `${item.price.formatted} / ${item.pricingUnitSymbol}` : item.price.formatted
